import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { memo } from 'react';
import { EMPTY_PROPERTY_VALUE } from '../../constants/EmptyPropertyValue';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { useTieredPricingModal } from '../../v2/hooks/useTieredPricingModal';
import { useHasMissingTieredPrices } from './hooks/useHasMissingTieredPrices';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PropertyInputTieredPrice = () => {
  useComponentMountMetric('PropertyInputTieredPrice');
  const {
    openModal,
    canOpenModal,
    modal
  } = useTieredPricingModal();
  const isMissingPricesForCurrency = useHasMissingTieredPrices();
  if (isMissingPricesForCurrency) {
    return EMPTY_PROPERTY_VALUE;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [modal, /*#__PURE__*/_jsx(Button, {
      size: "xs",
      use: "tertiary-light",
      onClick: openModal,
      "data-test-id": "tiered-price-view-tiers-btn",
      disabled: !canOpenModal,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataProperties.tieredPricing.button.viewTiers"
      })
    })]
  });
};
export default /*#__PURE__*/memo(PropertyInputTieredPrice);